import { render, staticRenderFns } from "./AdministracaoSistema.vue?vue&type=template&id=422c3916&"
import script from "./AdministracaoSistema.vue?vue&type=script&lang=js&"
export * from "./AdministracaoSistema.vue?vue&type=script&lang=js&"
import style0 from "./AdministracaoSistema.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports